export default {
  //apiUrl: 'https://api-misdashboard-qa.shopster.live/api',//QA
  // apiUrl: 'https://localhost:5001/api',
  //  apiUrl: 'https://api-preprod-misdashboard.shopster.live/api',//UAT
  apiUrl: 'https://api-misdashboard.shopster.live/api',//PROD
};